export enum PrimaryTypeEnum {
  HOT_NEW = 'HOT_NEW',
  NEW = 'NEW',
  TOP_CHART = 'TOP_CHART',
  ENDED = 'ENDED',
  CONTENT = 'CONTENT',
  ALL = 'ALL',
}
